import { actions } from 'xstate';

const { cancel, send } = actions;

export const sendDebouncedSortByEvent = send('DEBOUNCED_SORT_BY', {
  delay: 200,
  id: 'debounced-sortBy',
});

export const cancelDebouncedSortByEvent = cancel('debounced-sortBy');
